/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles';
import Swipe from 'react-easy-swipe';

import arrowRight from './arrow-right.svg';

const AUTO_PLAY_INTERVAL = 2000;
const IPAD_BREAKPOINT = 769;
export default class Slider extends SafePureComponent {
  state = {
    index: 0,
    width: 0,
  };
  constructor(props) {
    super(props);

    // this.state = {
    //   index: 0,
    //   width: 0,
    // };
    this.swipingLeft = this.swipingLeft.bind(this);
    this.swipingRight = this.swipingRight.bind(this);
    this.selectSlide = this.selectSlide.bind(this);
    this.renderNextButton = this.renderNextButton.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  renderChildSlides = (currentIndex, children) => {
    return React.Children.toArray(children).reduce(
      (childrenToRender, _, index) => {
        if (index < currentIndex - 1 || index > currentIndex + 1) {
          return childrenToRender;
        }
        let newSlideIndex = index;
        let newIndex = index;
        let classes = 'slide';
        if (index === currentIndex) {
          classes = 'slide current';
        }
        if (index === currentIndex - 1) {
          classes = 'slide previous';
          newSlideIndex = currentIndex - 1;
        }
        if (index === currentIndex + 1) {
          classes = 'slide next';
          newSlideIndex = currentIndex + 1;
        }

        let tempArr = [
          ...childrenToRender,
          <div
            key={index}
            className={classes}
            aria-hidden="true"
            onClick={() => this.selectSlide(newSlideIndex)}
          >
            {children[newIndex]}
          </div>,
        ];

        if (tempArr.length == 2 && currentIndex === children.length - 1) {
          tempArr.push(
            <div
              key={0}
              className="slide next"
              aria-hidden="true"
              onClick={() => this.selectSlide(newSlideIndex)}
            >
              {children[0]}
            </div>,
          );
        }

        return tempArr;
      },
      [],
    );
  };

  selectSlide = index => () => {
    if (index < 0) {
      index = this.props.children.length - 1;
    }
    if (index > this.props.children.length - 1) {
      index = 0;
    }
    this.setState({ ...this.state, index });
  };

  renderDotIndicators = (currentIndex, children) => {
    return children.map((_, index) => {
      const classes = index === currentIndex ? 'indicator' : '';
      return <div key={`dot-${index}`} className={classes}></div>;
    });
  };

  renderNextButton = (currentIndex, children) => {
    if (this.props.children.length == 1) {
      return;
    }
    const { width } = this.state;

    const nextClassnames =
      currentIndex + 1 < React.Children.count(children)
        ? 'right_arrow'
        : 'right_arrow in-active-';
    const prevClassnames =
      currentIndex - 1 > -1 ? 'left_arrow' : 'left_arrow in-active-';

    if (IPAD_BREAKPOINT > width || 1) {
      // ipad view
      return (
        <React.Fragment>
          <div className="centerimagebg">
            <div
              className="leftarrowbg"
              role="button"
              aria-hidden="true"
              onClick={this.selectSlide(currentIndex - 1)}
            >
              <button className={prevClassnames} type="button">
                <img src={arrowRight} alt="left-arrow" />
              </button>
            </div>
            <div
              className="rightarrowbg"
              role="button"
              aria-hidden="true"
              onClick={this.selectSlide(currentIndex + 1)}
            >
              <button className={nextClassnames} type="button">
                <img src={arrowRight} alt="right-arrow" />
              </button>
            </div>
          </div>
          <div className="leftrightarrow"></div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="centerimagebg">
          <div className="leftarrowbg" role="button" aria-hidden="true">
            <button
              className={prevClassnames}
              type="button"
              onClick={this.selectSlide(currentIndex - 1)}
            >
              <img src={arrowRight} alt="left-arrow" />
            </button>
          </div>
          <div className="rightarrowbg" role="button" aria-hidden="true">
            <button
              className={nextClassnames}
              type="button"
              onClick={this.selectSlide(currentIndex + 1)}
              // onClick={this.selectSlide.bind(this, currentIndex + 1)}
            >
              <img src={arrowRight} alt="right-arrow" />
            </button>
          </div>
        </div>
        <div className="leftrightarrow"></div>
      </React.Fragment>
    );
  };

  _startAutoSlider = () => {
    const { index } = this.state;
    let nextIndex = index + 1;
    if (nextIndex > this.props.children.length - 1) {
      nextIndex = 0;
    }

    this.setState({ ...this.state, index: nextIndex });
  };

  startAutoSlider = () => {
    if (this.props.children.length > 1) {
      const { index } = this.state;
      this.autoTimeInterval = setInterval(() => {
        this._startAutoSlider(index);
      }, AUTO_PLAY_INTERVAL);
    }
  };

  stopAutoSlider = () => {
    if (this.props.children.length > 1) {
      if (this.autoTimeInterval) {
        clearInterval(this.autoTimeInterval);
      }
    }
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  componentDidMount() {
    this.startAutoSlider();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    this.stopAutoSlider();
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  swipingLeft = () => {
    const { index } = this.state;
    let nextIndex = index + 1;
    if (nextIndex > this.props.children.length - 1) {
      nextIndex = 0;
    }
    this.setState({ index: nextIndex });
  };

  swipingRight = () => {
    const { index } = this.state;
    let nextIndex = index - 1;
    if (nextIndex < 0) {
      nextIndex = this.props.children.length - 1;
    }
    this.setState({ index: nextIndex });
  };

  safeRender() {
    return (
      <Swipe
        onSwipeLeft={this.swipingLeft}
        onSwipeRight={this.swipingRight}
        onSwipeStart={this.stopAutoSlider}
        onSwipeEnd={this.startAutoSlider}
      >
        <div
          aria-hidden="true"
          css={styles.customSliderStyle}
          onMouseEnter={this.stopAutoSlider}
          onMouseLeave={this.startAutoSlider}
        >
          <div className="indicators">
            {this.renderNextButton(this.state.index, this.props.children)}
          </div>
          <div className="slider">
            <div className="content-wrapper">
              <div className="content">
                <CSSTransitionGroup
                  transitionName="slide"
                  transitionEnterTimeout={300}
                  transitionLeaveTimeout={300}
                >
                  {this.renderChildSlides(
                    this.state.index,
                    this.props.children,
                  )}
                </CSSTransitionGroup>
              </div>
              <div className="pagination">
                {this.renderDotIndicators(
                  this.state.index,
                  this.props.children,
                )}
              </div>
            </div>
          </div>
        </div>
      </Swipe>
    );
  }
}
